import { useLocaleFormat } from '../../i18n/useLocaleFormat'
import { useActiveWalletBalance } from './useActiveWalletBalance'

/** The account-menu number follows the same wallet and access as the switcher. */
export default function ActiveWalletMenuBalance() {
  const { wallet, query, balance } = useActiveWalletBalance()
  const { formatNumber } = useLocaleFormat()
  if (!wallet.canViewFinancials || query.isLoading || query.isError || balance === undefined || balance === null || !Number.isSafeInteger(balance)) return null
  return <span data-testid="header-usage-credits-balance" className="tabular-nums text-white/80">{formatNumber(balance)}</span>
}
